var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeAc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.6667,
    height: 16.6667,
    viewBox: "0 0 16.6667 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 15.8333V2.5C14.1667 1.57953 13.4205 0.833333 12.5 0.833333H4.16667C3.24619 0.833333 2.5 1.57953 2.5 2.5V15.8333M14.1667 15.8333H15.8333M14.1667 15.8333H10M2.5 15.8333H0.833333M2.5 15.8333H6.66667M5.83333 4.16667H6.66667M5.83333 7.5H6.66667M10 4.16667H10.8333M10 7.5H10.8333M6.66667 15.8333V11.6667C6.66667 11.2064 7.03976 10.8333 7.5 10.8333H9.16667C9.6269 10.8333 10 11.2064 10 11.6667V15.8333M6.66667 15.8333H10",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeAc);
export default __webpack_public_path__ + "static/media/tree-ac.05d294fd2a70db30684ea6f3cc7106ec.svg";
export { ForwardRef as ReactComponent };